(function () {
  const initSliderInSection = (section) => {
    const sliders = section.querySelectorAll(".carousel-coup-de-coeur__slider");

    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll(".swiper-slide");
      const isSingle = slides.length === 1;

      if (isSingle) slider.classList.add("is-single");
      else slider.classList.remove("is-single");

      let columns1360 = Number(slider.dataset.columns);
      let columns1200 = 3;

      if (columns1360 === 5) columns1200 = 4;
      else if (columns1360 < 3) columns1200 = columns1360;

      let columns990 = 3;
      if (columns1360 < 3) columns990 = columns1200;

      let columns990PerView = Number(columns990 + 0.05);

      let columns576 = 2;
      if (columns1360 < 2) columns576 = columns990;

      let columns576PerView = Number(columns576 + 0.05);

      const nav = section.querySelector(".carousel-coup-de-coeur__slider-nav");
      const nextEl = nav ? nav.querySelector(".swiper-button-next") : null;
      const prevEl = nav ? nav.querySelector(".swiper-button-prev") : null;

      if (slider.classList.contains("swiper-initialized")) return;

      const swiperConfig = isSingle
        ? {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 8,
            watchSlidesProgress: true,
            speed: 1000,
            allowTouchMove: false,
            navigation: false,
            breakpoints: {
              576: { slidesPerView: 1, slidesPerGroup: 1 },
              990: { slidesPerView: 1, slidesPerGroup: 1 },
              1200: { slidesPerView: 1, slidesPerGroup: 1 },
              1360: { slidesPerView: 1, slidesPerGroup: 1 },
            },
          }
        : {
            slidesPerView: 2,
            spaceBetween: 8,
            watchSlidesProgress: true,
            speed: 1000,
            allowTouchMove: true,
            navigation: { nextEl, prevEl },
            breakpoints: {
              576: { slidesPerView: columns576PerView, slidesPerGroup: columns576 },
              990: { slidesPerView: columns990PerView, slidesPerGroup: columns990 },
              1200: { slidesPerView: columns1200, slidesPerGroup: columns1200 },
              1360: { slidesPerView: columns1360, slidesPerGroup: columns1360 },
            },
          };

      new Swiper(slider, swiperConfig);
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll(".section-carousel-coup-de-coeur");
    sections.forEach((section) => initSliderInSection(section));
  };

  initSection();

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });
})();
